import { reduxKey } from '../../constants';
import { NotificationsState } from '../../types';

export function getState(state): NotificationsState {
  return state[reduxKey] ?? {};
}
